var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33337 7.99988L8.00004 10.6665M8.00004 10.6665L10.6667 7.99988M8.00004 10.6665V4.53321C8.00004 3.60607 8.00004 3.1425 7.63303 2.62348C7.38918 2.27862 6.68709 1.853 6.26856 1.79629C5.63863 1.71095 5.39942 1.83573 4.92099 2.08531C2.78893 3.1975 1.33337 5.42871 1.33337 7.99988C1.33337 11.6818 4.31814 14.6665 8.00004 14.6665C11.6819 14.6665 14.6667 11.6818 14.6667 7.99988C14.6667 5.53227 13.326 3.37779 11.3334 2.22509",
    stroke: "#395BA9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload04);
export default __webpack_public_path__ + "static/media/download-04.f36418642ea4d07b0e0e82b100365480.svg";
export { ForwardRef as ReactComponent };